import React, { useState } from 'react';
import { 
  Mail, Star, Award, Users, Building2, 
  ChevronDown, ChevronUp
} from 'lucide-react';
import { useLanguage } from './LanguageContext';

interface TeamMember {
  id: string;
  name: string;
  roleEn: string;
  roleDe: string;
  email: string;
  image: string;
}

const founders: TeamMember[] = [
  {
    id: 'michael',
    name: 'Michael Menter',
    roleEn: 'Chairman of the Board',
    roleDe: 'Vorstandsvorsitzender',
    email: 'michael@investmenter.de',
    image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Michael-Menter-1-scaled-e1767341230725-1619x2048.png'
  },
  {
    id: 'jim',
    name: 'Jim Menter',
    roleEn: 'Co-Founder',
    roleDe: 'Mitgründer',
    email: 'jim@investmenter.de',
    image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Jim-1-scaled-e1767340398236-1655x2048.png'
  },
  {
    id: 'brigitte',
    name: 'Brigitte Menter',
    roleEn: 'Co-Founder',
    roleDe: 'Mitgründerin',
    email: 'brigitte@investmenter.de',
    image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Brigitte-1-scaled-e1767341032900-1380x1536.png'
  },
  {
    id: 'kiano',
    name: 'Kiano Loehr',
    roleEn: 'Co-Founder',
    roleDe: 'Mitgründer',
    email: 'kiano@investmenter.de',
    image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Kiano-1-scaled-e1767341107978.png'
  }
];

const teamMembers: TeamMember[] = [
  { id: 'julia', name: 'Julia Kijasko', roleEn: 'Tax Consultant', roleDe: 'Steuerberaterin', email: 'j.kijasko@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/03/Untitled-design-2025-03-03T083344.420-e1767338117620.png' },
  { id: 'paula', name: 'Paula Lebrecht', roleEn: 'Setter', roleDe: 'Setter', email: 'p.lebrecht@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Paula-1-scaled.png.webp' },
  { id: 'yehia', name: 'Yehia Ahmed', roleEn: 'Real Estate Administrator', roleDe: 'Immobilienverwalter', email: 'm.manuguid@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/11/Yehia-4000-x-4000-1-1-2048x2048.png.webp' },
  { id: 'john-acojido', name: 'John Reneil Acojido', roleEn: 'Corporate Services Coordinator', roleDe: 'Unternehmensdienstleistungskoordinator', email: 'j.acojido@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/12/DSC01276-1-1-1-1-scaled-e1767341329886-2048x1651.png' },
  { id: 'jerome', name: 'Jerome Masagca', roleEn: 'HR Manager', roleDe: 'HR Manager', email: 'j.masagca@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-15-1-2048x1930.png.webp' },
  { id: 'jeanny', name: 'Jeanny Lyn Emperador', roleEn: 'HR & Admin Executive', roleDe: 'HR & Admin Executive', email: 'j.emperador@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/12/Jennie-PROFILE-PICTURE-1-2-1812x2048.png.webp' },
  { id: 'joana', name: 'Joana Reyes', roleEn: 'Tech Lead', roleDe: 'Tech Lead', email: 'j.reyes@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/03/Untitled-design-2025-03-03T131903.768.png.webp' },
  { id: 'john-zapanta', name: 'John Zapanta', roleEn: 'Technical Specialist', roleDe: 'Technischer Spezialist', email: 'j.zapanta@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/03/Untitled-design-2025-03-03T081124.416.png.webp' },
  { id: 'shahmir', name: 'Shahmir Gill', roleEn: 'Software & Automation Specialist', roleDe: 'Software & Automatisierungsspezialist', email: 's.gill@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/03/Untitled-design-2025-03-03T081605.832.png.webp' },
  { id: 'ashif', name: 'Ashif Maniyaram Kunnath', roleEn: 'Senior Accountant', roleDe: 'Senior Buchhalter', email: 'a.maniyaram@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/new-agent-02-7-scaled.png.webp' },
  { id: 'sohail', name: 'Sohail Awan', roleEn: 'Senior Accountant', roleDe: 'Senior Buchhalter', email: 's.awan@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/03/Untitled-design-2025-03-03T082321.645.png.webp' },
  { id: 'ravali', name: 'Ravali Osolla', roleEn: 'Junior Accountant', roleDe: 'Junior Buchhalterin', email: 'r.osolla@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-8.png.webp' },
  { id: 'fatima', name: 'Fatima Haider', roleEn: 'Performance Marketing Manager', roleDe: 'Performance Marketing Manager', email: 'f.haider@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-11-scaled.png.webp' },
  { id: 'zara', name: 'Zara Imtiaz', roleEn: 'Graphic Designer', roleDe: 'Grafikdesignerin', email: 'z.imtiaz@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-14-2048x1831.png.webp' },
  { id: 'marshall', name: 'Marshall George', roleEn: 'Media Incharge', roleDe: 'Medienverantwortlicher', email: 'm.george@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Marshal-1-4-2048x1851.png.webp' },
  { id: 'angelo', name: 'Angelo Papio', roleEn: 'Social Media Coordinator', roleDe: 'Social Media Koordinator', email: 'a.papio@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-13-2048x1831.png.webp' },
  { id: 'dana', name: 'Dana Espejo', roleEn: 'Social Media Coordinator', roleDe: 'Social Media Koordinatorin', email: 'd.espejo@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Dana-Profile-Picture-1-scaled.png.webp' },
  { id: 'sara', name: 'Sara Parsa', roleEn: 'Executive Assistant', roleDe: 'Assistentin der Geschäftsführung', email: 's.parsa@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Sara-1-1-2048x2027.png.webp' },
  { id: 'jayne', name: 'Jayne Fuentes', roleEn: 'Executive Assistant', roleDe: 'Assistentin der Geschäftsführung', email: 'j.fuentes@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/03/Untitled-design-2025-03-03T131937.403.png.webp' },
  { id: 'precious', name: 'Precious Maban', roleEn: 'Executive Assistant', roleDe: 'Assistentin der Geschäftsführung', email: 'p.maban@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Precious-Profile-Picture-1-1-scaled.png.webp' },
  { id: 'jemaira', name: 'Jemaira Ricaro', roleEn: 'Executive Assistant', roleDe: 'Assistentin der Geschäftsführung', email: 'j.ricaro@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-9-1.png.webp' },
  { id: 'mannylyn', name: 'Mannylyn Soriano', roleEn: 'Sales Support Lead', roleDe: 'Vertriebsunterstützung Lead', email: 'm.soriano@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-10.png.webp' },
  { id: 'gabrielle', name: 'Gabrielle Joloc', roleEn: 'Executive Assistant', roleDe: 'Assistentin der Geschäftsführung', email: 'g.joloc@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-5.png.webp' },
  { id: 'sheryll', name: 'Sheryll Anne Blancaflor', roleEn: 'Events Coordinator', roleDe: 'Veranstaltungskoordinatorin', email: 's.blancaflor@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2026/01/Sheryll-1-scaled-e1767337780863.png' },
  { id: 'baina', name: 'Baina Dani', roleEn: 'Office Assistant', roleDe: 'Büroassistentin', email: 'b.dani@investmenter.de', image: 'https://dubai-immobilie-kaufen.de/wp-content/uploads/2025/08/new-agent-02-12-1794x2048.png.webp' }
];

interface AboutUsViewProps {
  onBack?: () => void;
}

const AboutUsView: React.FC<AboutUsViewProps> = ({ onBack }) => {
  const { t, language } = useLanguage();
  const [imageErrors, setImageErrors] = useState<Set<string>>(new Set());
  const [showAllTeam, setShowAllTeam] = useState(false);

  const handleImageError = (id: string) => {
    setImageErrors(prev => new Set(prev).add(id));
  };

  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  };

  const openEmail = (email: string) => {
    if (email) window.location.href = `mailto:${email}`;
  };

  const displayedTeam = showAllTeam ? teamMembers : teamMembers.slice(0, 6);

  // Translations
  const texts = {
    aboutUs: language === 'de' ? 'Über Uns' : 'About Us',
    headline: language === 'de' 
      ? 'Der #1 Immobilienmakler für deutsche Investoren in Dubai'
      : 'The #1 real estate agent for German investors in Dubai',
    reviews: language === 'de' ? 'Bewertungen' : 'reviews',
    googleReviews: language === 'de' ? 'Google Bewertungen' : 'Google Reviews',
    rating: language === 'de' ? 'Bewertung' : 'Rating',
    happyInvestors: language === 'de' ? 'Zufriedene Investoren' : 'Happy Investors',
    assetsManaged: language === 'de' ? 'Verwaltetes Vermögen' : 'Assets Managed',
    benefitTitle: language === 'de' ? 'So profitieren Sie' : 'So that you benefit',
    visionTitle: language === 'de' ? 'Unsere Vision ist ...' : 'Our vision is to ...',
    visionText1: language === 'de'
      ? '… DAS führende deutsche Immobilienunternehmen in Dubai zu sein und die höchste Kundenzufriedenheit zu erreichen.'
      : '… To be THE leading German real estate company in Dubai and to achieve the highest level of customer satisfaction.',
    visionText2: language === 'de'
      ? 'Unser Ziel ist es, nicht nur Kunden zu haben, sondern wahre Fans, die unsere Leidenschaft für Luxusimmobilien in Dubai teilen.'
      : 'Our goal is not only to have customers, but true fans who share our passion for luxury real estate in Dubai.',
    visionText3: language === 'de'
      ? 'Durch unsere jahrzehntelange Erfahrung und das höchste Maß an Expertise in der Immobilienbranche streben wir danach, Marktführer im Bereich Luxusimmobilien zu sein. Wir konzentrieren uns auf höchste Qualität in allen Aspekten unserer Dienstleistungen und bieten unseren Kunden herausragende Renditen. Unser Anspruch bei Dubai Real Estate ist es, unseren Kunden die komplette Arbeit abzunehmen.'
      : 'Through our decades of experience and the highest level of expertise in the real estate industry, we strive to be the market leader in the field of luxury real estate. We focus on the highest quality in all aspects of our services and offer our clients outstanding returns. Our claim at Dubai Real Estate is to take the complete work off our clients\' hands.',
    foundersTitle: language === 'de' ? 'Unsere Gründer' : 'Our Founders',
    teamTitle: language === 'de' ? 'Unser Team' : 'Our Team',
    showAll: language === 'de' ? 'Alle Teammitglieder anzeigen' : 'Show All Team Members',
    showLess: language === 'de' ? 'Weniger anzeigen' : 'Show Less',
    whyTitle: language === 'de' 
      ? 'Darum kaufen Deutsche gerne bei InvestMenter'
      : "That's why Germans like to buy from InvestMenter",
    footer: 'The InvestMenter Way – Values Across Generations'
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#fff',
      paddingBottom: '100px'
    }}>
      {/* Hero Section - Dark with background */}
      <div style={{
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.7)), url(https://dubai-immobilie-kaufen.de/wp-content/uploads/2023/11/dubai-skyline.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '50px 20px 40px',
        textAlign: 'center'
      }}>
        {/* Badge */}
        <div style={{
          display: 'inline-block',
          backgroundColor: 'rgba(255,255,255,0.2)',
          color: '#fff',
          fontSize: '10px',
          fontWeight: '700',
          padding: '6px 14px',
          borderRadius: '20px',
          textTransform: 'uppercase',
          letterSpacing: '1.5px',
          marginBottom: '16px',
          backdropFilter: 'blur(10px)'
        }}>
          {texts.aboutUs}
        </div>

        <h1 style={{ 
          color: '#fff', 
          fontSize: '24px', 
          fontWeight: '700',
          fontFamily: 'Georgia, serif',
          marginBottom: '20px',
          lineHeight: '1.3',
          maxWidth: '340px',
          margin: '0 auto 20px'
        }}>
          {texts.headline}
        </h1>

        {/* Google Rating */}
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span style={{ color: '#fff', fontSize: '12px', fontWeight: '600' }}>{t('abtExcellent')}</span>
          <span style={{ color: '#fbbf24', fontSize: '14px' }}>★★★★★</span>
          <span style={{ color: '#fff', fontSize: '12px' }}>194 {texts.reviews}</span>
          <span style={{ 
            background: 'linear-gradient(90deg, #4285f4, #ea4335, #fbbc05, #34a853)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: '13px',
            fontWeight: '700'
          }}>Google</span>
        </div>
      </div>

      {/* Stats Section */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1px',
        backgroundColor: '#e5e5e5',
        margin: '0'
      }}>
        {[
          { value: '104+', label: texts.googleReviews, icon: Star },
          { value: '5.0', label: texts.rating, icon: Award },
          { value: '50+', label: texts.happyInvestors, icon: Users },
          { value: '€50M+', label: texts.assetsManaged, icon: Building2 },
        ].map((stat, index) => {
          const IconComp = stat.icon;
          return (
            <div key={index} style={{
              backgroundColor: '#1a1a1a',
              padding: '24px 16px',
              textAlign: 'center'
            }}>
              <IconComp size={24} color="#D6B160" style={{ marginBottom: '8px' }} />
              <div style={{ color: '#fff', fontSize: '26px', fontWeight: '700', marginBottom: '4px' }}>
                {stat.value}
              </div>
              <div style={{ color: '#888', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {stat.label}
              </div>
            </div>
          );
        })}
      </div>

      {/* Benefit Section - White Background */}
      <div style={{ padding: '40px 20px', backgroundColor: '#fff' }}>
        <h2 style={{ 
          color: '#1a1a1a', 
          fontSize: '24px', 
          fontWeight: '700',
          fontFamily: 'Georgia, serif',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          {texts.benefitTitle}
        </h2>

        {/* Video Section - Autoplay */}
        <div style={{
          borderRadius: '12px',
          overflow: 'hidden',
          marginBottom: '24px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          aspectRatio: '16/9'
        }}>
          <iframe
            src="https://fast.wistia.net/embed/iframe/i4ucjax8y8?autoPlay=true&silentAutoPlay=false&muted=false&controlsVisibleOnLoad=true&playButton=false"
            style={{ 
              width: '100%', 
              height: '100%', 
              border: 'none'
            }}
            allow="autoplay; fullscreen"
            allowFullScreen
            title="InvestMenter Video"
          />
        </div>

        {/* Vision Text */}
        <h3 style={{ 
          color: '#1a1a1a', 
          fontSize: '20px', 
          fontWeight: '700',
          fontFamily: 'Georgia, serif',
          marginBottom: '16px'
        }}>
          {texts.visionTitle}
        </h3>
        <p style={{ color: '#444', fontSize: '14px', lineHeight: '1.7', marginBottom: '12px' }}>
          {texts.visionText1}
        </p>
        <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.7', marginBottom: '12px' }}>
          {texts.visionText2}
        </p>
        <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.7' }}>
          {texts.visionText3}
        </p>
      </div>

      {/* Founders Section - Light Gray Background */}
      <div style={{ padding: '40px 20px', backgroundColor: '#f8f8f8' }}>
        <h2 style={{ 
          color: '#1a1a1a', 
          fontSize: '24px', 
          fontWeight: '700',
          fontFamily: 'Georgia, serif',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          {texts.foundersTitle}
        </h2>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(2, 1fr)', 
          gap: '16px' 
        }}>
          {founders.map((member) => (
            <div 
              key={member.id}
              onClick={() => openEmail(member.email)}
              style={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                overflow: 'hidden',
                cursor: 'pointer',
                boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
              }}
            >
              <div style={{
                aspectRatio: '1',
                backgroundColor: '#f0f0f0',
                overflow: 'hidden'
              }}>
                {!imageErrors.has(member.id) ? (
                  <img 
                    src={member.image}
                    alt={member.name}
                    onError={() => handleImageError(member.id)}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'top'
                    }}
                  />
                ) : (
                  <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#e8e8e8'
                  }}>
                    <span style={{ fontSize: '32px', fontWeight: '700', color: '#999' }}>
                      {getInitials(member.name)}
                    </span>
                  </div>
                )}
              </div>
              <div style={{ padding: '16px' }}>
                <h3 style={{ color: '#1a1a1a', fontSize: '15px', fontWeight: '700', marginBottom: '4px' }}>
                  {member.name}
                </h3>
                <p style={{ color: '#666', fontSize: '12px', marginBottom: '8px' }}>
                  {language === 'de' ? member.roleDe : member.roleEn}
                </p>
                <p style={{ color: '#D6B160', fontSize: '11px', fontWeight: '600' }}>
                  {member.email}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Team Section - White Background */}
      <div style={{ padding: '40px 20px', backgroundColor: '#fff' }}>
        <h2 style={{ 
          color: '#1a1a1a', 
          fontSize: '24px', 
          fontWeight: '700',
          fontFamily: 'Georgia, serif',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          {texts.teamTitle}
        </h2>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(3, 1fr)', 
          gap: '12px' 
        }}>
          {displayedTeam.map((member) => (
            <div 
              key={member.id}
              onClick={() => openEmail(member.email)}
              style={{
                backgroundColor: '#f8f8f8',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer'
              }}
            >
              <div style={{
                aspectRatio: '1',
                backgroundColor: '#e8e8e8',
                overflow: 'hidden'
              }}>
                {!imageErrors.has(member.id) ? (
                  <img 
                    src={member.image}
                    alt={member.name}
                    onError={() => handleImageError(member.id)}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'top'
                    }}
                  />
                ) : (
                  <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <span style={{ fontSize: '20px', fontWeight: '700', color: '#999' }}>
                      {getInitials(member.name)}
                    </span>
                  </div>
                )}
              </div>
              <div style={{ padding: '10px 8px' }}>
                <h3 style={{ color: '#1a1a1a', fontSize: '11px', fontWeight: '700', marginBottom: '2px', lineHeight: '1.3' }}>
                  {member.name}
                </h3>
                <p style={{ color: '#666', fontSize: '9px', lineHeight: '1.3' }}>
                  {language === 'de' ? member.roleDe : member.roleEn}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Show More Button */}
        <button
          onClick={() => setShowAllTeam(!showAllTeam)}
          style={{
            width: '100%',
            marginTop: '20px',
            padding: '14px',
            backgroundColor: '#1a1a1a',
            border: 'none',
            borderRadius: '12px',
            color: '#D6B160',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          {showAllTeam ? (
            <>{texts.showLess} <ChevronUp size={18} /></>
          ) : (
            <>{texts.showAll} ({teamMembers.length}) <ChevronDown size={18} /></>
          )}
        </button>
      </div>

      {/* Why Germans Section */}
      <div style={{ padding: '40px 20px', backgroundColor: '#f5f5f5' }}>
        <h2 style={{ 
          color: '#1a1a1a', 
          fontSize: '22px', 
          fontWeight: '700',
          fontFamily: 'Georgia, serif',
          textAlign: 'center',
          marginBottom: '30px',
          lineHeight: '1.3'
        }}>
          {texts.whyTitle}
        </h2>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          {/* Row 1: Experience + Selective */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            {/* Experience and expertise - White with border */}
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '20px',
              padding: '20px',
              border: '1px solid #e5e5e5'
            }}>
              <h3 style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Erfahrung und Expertise' : 'Experience and expertise'}
              </h3>
              <p style={{ color: '#666', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de' 
                  ? 'Mit über 35 Jahren Erfahrung im Immobiliengeschäft bieten wir umfassende Expertise als Projektentwickler und Makler.'
                  : 'With over 35 years in real estate, we offer comprehensive expertise as a property developer and broker.'}
              </p>
            </div>

            {/* Selective Object Selection - Gold with image */}
            <div style={{
              backgroundImage: 'linear-gradient(rgba(214, 177, 96, 0.9), rgba(214, 177, 96, 0.85)), url(https://dubai-immobilie-kaufen.de/wp-content/uploads/2023/11/dubai-skyline.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '20px',
              padding: '20px'
            }}>
              <h3 style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Selektive Objektauswahl' : 'Selective Object Selection'}
              </h3>
              <p style={{ color: 'rgba(0,0,0,0.7)', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Nur Immobilien in Top-Lagen mit höchster Bauqualität für Exklusivität Ihrer Investition.'
                  : 'Only properties in top locations with highest construction quality for your investment exclusivity.'}
              </p>
            </div>
          </div>

          {/* Active investment - White with gold corner accent */}
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '20px',
            padding: '20px',
            border: '1px solid #e5e5e5',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: '-20px',
              right: '-20px',
              width: '80px',
              height: '80px',
              border: '2px solid #D6B160',
              borderRadius: '50%',
              opacity: 0.3
            }} />
            <h3 style={{ color: '#1a1a1a', fontSize: '15px', fontWeight: '700', marginBottom: '10px' }}>
              {language === 'de' ? 'Aktive Investition' : 'Active investment'}
            </h3>
            <p style={{ color: '#666', fontSize: '12px', lineHeight: '1.6' }}>
              {language === 'de'
                ? 'Wir investieren selbst in die meisten angebotenen Immobilien, was unser Vertrauen in die Qualität und Rentabilität unserer Angebote unterstreicht.'
                : 'We invest in most of the properties on offer ourselves, which underlines our confidence in the quality and profitability of our listings.'}
            </p>
          </div>

          {/* Row 2: Access to network + Comprehensive expertise */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            {/* Access to exclusive network - Dark gold with image */}
            <div style={{
              backgroundImage: 'linear-gradient(rgba(180, 140, 60, 0.92), rgba(160, 120, 40, 0.95)), url(https://dubai-immobilie-kaufen.de/wp-content/uploads/2023/11/dubai-skyline.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '20px',
              padding: '20px'
            }}>
              <h3 style={{ color: '#fff', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Zugang zu einem exklusiven Netzwerk' : 'Access to an exclusive network'}
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Profitieren Sie von unserem einzigartigen Netzwerk in Dubai für Ihre Immobilienträume.'
                  : 'Benefit from our unique network in Dubai to achieve your real estate dreams.'}
              </p>
            </div>

            {/* Comprehensive expertise - Light beige */}
            <div style={{
              backgroundColor: '#f9f6f0',
              borderRadius: '20px',
              padding: '20px',
              border: '1px solid #e8e4dc'
            }}>
              <h3 style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Umfassende Expertise in allen Bereichen' : 'Comprehensive expertise in all areas'}
              </h3>
              <p style={{ color: '#666', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Steuerrechtsanwälte mit Akkreditierungen in Deutschland und Dubai für kompetente Beratung.'
                  : 'Tax specialist lawyers with accreditations in Germany and Dubai for competent advice.'}
              </p>
            </div>
          </div>

          {/* Row 3: German quality + Exclusive networks */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            {/* German quality in Dubai */}
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '20px',
              padding: '20px',
              border: '1px solid #e5e5e5'
            }}>
              <h3 style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Deutsche Qualität in Dubai' : 'German quality in Dubai'}
              </h3>
              <p style={{ color: '#666', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Wir bringen den deutschen Qualitätsstandard nach Dubai für Sicherheit und Rentabilität.'
                  : 'We bring the German quality standard to Dubai to guarantee safety and profitability.'}
              </p>
            </div>

            {/* Exclusive investor networks */}
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '20px',
              padding: '20px',
              border: '1px solid #e5e5e5'
            }}>
              <h3 style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Exklusive Investorennetzwerke' : 'Exclusive investor networks'}
              </h3>
              <p style={{ color: '#666', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Unser hochwertiges Netzwerk ermöglicht schnelle und effektive Verkaufsprozesse.'
                  : 'Our high-quality network enables fast and effective sales processes.'}
              </p>
            </div>
          </div>

          {/* Row 4: Access to best units + Diversification */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            {/* Access to the best units - Light gold */}
            <div style={{
              backgroundColor: '#D6B160',
              borderRadius: '20px',
              padding: '20px'
            }}>
              <h3 style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Zugang zu den besten Einheiten' : 'Access to the best units'}
              </h3>
              <p style={{ color: 'rgba(0,0,0,0.7)', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Dank unserer Kontakte zu führenden Entwicklern haben Sie Zugang zu erstklassigen Immobilien.'
                  : 'Thanks to our contacts with leading developers, you will have access to first-class properties.'}
              </p>
            </div>

            {/* Diversification and security - Dark gray */}
            <div style={{
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '20px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Decorative icon */}
              <div style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                opacity: 0.15
              }}>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1">
                  <circle cx="12" cy="12" r="10"/>
                  <circle cx="12" cy="12" r="4"/>
                  <line x1="12" y1="2" x2="12" y2="6"/>
                  <line x1="12" y1="18" x2="12" y2="22"/>
                  <line x1="2" y1="12" x2="6" y2="12"/>
                  <line x1="18" y1="12" x2="22" y2="12"/>
                </svg>
              </div>
              <h3 style={{ color: '#D6B160', fontSize: '14px', fontWeight: '700', marginBottom: '10px' }}>
                {language === 'de' ? 'Diversifikation und Sicherheit' : 'Diversification and security'}
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px', lineHeight: '1.5' }}>
                {language === 'de'
                  ? 'Diversifizieren Sie Ihr Vermögen in einer anderen Währung und auf einem anderen Kontinent.'
                  : 'Diversify your assets by investing in a different currency and continent to protect your wealth.'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ 
        textAlign: 'center', 
        padding: '40px 20px',
        backgroundColor: '#1a1a1a'
      }}>
        <p style={{ color: '#D6B160', fontSize: '16px', fontWeight: '600', fontStyle: 'italic', marginBottom: '12px' }}>
          {texts.footer}
        </p>
        <p style={{ color: '#666', fontSize: '12px' }}>
          © 2025 InvestMenter
        </p>
      </div>
    </div>
  );
};

export default AboutUsView;